const timestampToUI = (timestamp) => {
    if (!timestamp) return null; // Handle null or undefined timestamp
    const date = timestamp.toDate(); // Convert Firebase Timestamp to JS Date
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`; // Format as DD-MM-YYYY
};

export default timestampToUI;
